import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { MAX_PAGE_SIZE_DEFAULT } from '~/constants/srp';
import { useIsLoggedIn } from '~/context/common/UserContext';
import SuggestedFiltersContext from '~/context/srp/SuggestedFiltersContext';
import useGenerateAnalyticsData from '~/hooks/srp/useGenerateAnalyticsData';
import useGenerateInventoryRequest from '~/hooks/srp/useGenerateInventoryRequest';
import fetchSuggestedFilters from '~/services/srp/fetchSuggestedFilters';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetSuggestedFilters(): void {
  const {
    setSuggestedFiltersRequestId,
    suggestedFilters: { setData, setError, setLoaded, setLoading }
  } = useContext(SuggestedFiltersContext);

  const isLoggedIn = useIsLoggedIn();
  const generateAnalyticsData = useGenerateAnalyticsData();
  const { request, conditionalRequestedFeatures } = useGenerateInventoryRequest(
    MAX_PAGE_SIZE_DEFAULT,
    {
      includePageNumber: true,
      limitRequestedFeatures: !isLoggedIn
    }
  );

  useEffectWithController(
    controller => {
      if (request.dealershipId) return;

      setLoading();

      fetchSuggestedFilters(
        {
          ...request,
          analyticsData: generateAnalyticsData(),
          requestedFeatures: request.requestedFeatures.concat(
            ...conditionalRequestedFeatures
          ),
          numberOfSuggestedFilters: 10
        },
        controller
      )
        .then(({ data }) => {
          setData(data.suggestedFilters);
          setSuggestedFiltersRequestId(data.suggestedFiltersRequestId);
        })
        .catch(
          generateErrorLogger(
            'Suggested filters',
            {},
            { callback: setError, controller }
          )
        );
    },
    [
      conditionalRequestedFeatures,
      generateAnalyticsData,
      request,
      setData,
      setError,
      setLoaded,
      setLoading,
      setSuggestedFiltersRequestId
    ]
  );
}
